<template>
  <div class="canvasWrap" ref="canvasWrap" @mousewheel="canvasMousewheel">
    <img class="clipImg" :src="value.image_src" width="100%" height="100%" />
    <!-- <SyncSide /> -->
    <canvas ref="canvas" width="550" height="550" class="canvas"></canvas>
  </div>
</template>

<script>
import SyncSide from './syncSide'
import * as cc from 'my-design-canvas/desf4fc'
import * as ccTool from 'my_tool_for_canvas/des8de9'
import * as ccTool2 from 'canvas_tool_me/des24bc'
import { mapMutations, mapState, mapGetters } from 'vuex'
import { saveHistory } from '@/utils/util'
export default {
  name: 'CanvasComponet',
  data() {
    return {
      cmToInch: 0.3937008,
      timer: null,
      canObj: null
    }
  },
  components: { SyncSide },
  props: ['value', 'index', 'configData'],
  beforeDestroy() {},
  mounted() {
    console.log('time====', new Date().getTime(), this.index)
    // cc.perfLimitSizeTotal = 40000
    // cc.maxCacheSideLimit = 40000
    // cc.Object.prototype.objectCaching = true
    const canObj = new cc.Canvas(this.$refs.canvas, {
      preserveObjectStacking: true
    })
    canObj.historyUndo = []
    canObj.historyRedo = [canObj.toJSON()]
    canObj.layers = []
    canObj.redo = function(callBack) {
      const { length } = this.historyRedo
      if (length < 2) {
        return
      }
      const preState = this.historyRedo[length - 2]
      const avtiveState = this.historyRedo.splice(length - 1, 1)
      preState &&
        this.loadFromJSON(preState, () => {
          const { objects } = preState
          this.layers = objects
          callBack()
        })
      preState && this.historyUndo.push(avtiveState[0])
    }
    canObj.undo = function(callBack) {
      const { length } = this.historyUndo
      if (length < 1) {
        return
      }
      const avtiveState = this.historyUndo.splice(length - 1, 1)
      avtiveState[0] &&
        this.loadFromJSON(avtiveState[0], () => {
          const { objects } = avtiveState[0]
          this.layers = objects
          callBack()
        })

      avtiveState[0] && this.historyRedo.push(avtiveState[0])
    }
    ccTool(canObj)
    ccTool2(canObj)
    if (this.configData.showProduct) {
      if (this.getCopyProductId) {
        canObj.loadFromJSON(this.activeFabricListGroup[this.index].canObj, () => {
          canObj.renderAll()
          this.$nextTick(() => {
            canObj.layers = this.activeFabricListGroup[this.index].canObj.objects
            this.setRandom()
          })
        })
      }

      this.setFabricList({
        index: this.index,
        view_id: this.value.view_id,
        canObj: canObj
      })
    } else {
      canObj.loadFromJSON(this.activeFabricListGroup[this.index].canObj, () => {
        canObj.renderAll()
        this.$nextTick(() => {
          canObj.layers = this.activeFabricListGroup[this.index].canObj.objects
          this.setRandom()
        })
      })
      this.setFabricList({
        index: this.index,
        view_id: this.value.view_id,
        canObj: canObj
      })
    }
    canObj.on('object:moved', e => {
      if (e.target.time === this.activeGroupInfo.code) {
        const objects = canObj.getObjects()
        const group = objects.find(item => item.type === 'group')
        if (group) {
          group.set('left', e.target.left).setCoords()
          group.set('top', e.target.top).setCoords()
          canObj.renderAll()
        }
      } else {
        const objects = canObj.getObjects()
        const group = objects.find(item => item.type === 'group')
        if (group && group.time === e.target.time) {
          group.set('left', e.target.left).setCoords()
          group.set('top', e.target.top).setCoords()
          canObj.renderAll()
        }
      }
    })

    canObj.on('object:rotated', e => {
      if (e.target.time === this.activeGroupInfo.code) {
        const objects = canObj.getObjects()
        const group = objects.find(item => item.type === 'group')
        if (group) {
          group.set('angle', e.target.angle).setCoords()
          canObj.renderAll()
        }
      } else {
        const objects = canObj.getObjects()
        const group = objects.find(item => item.type === 'group')
        if (group && group.time === e.target.time) {
          group.set('angle', e.target.angle).setCoords()
          canObj.renderAll()
        }
      }
      const t = this.activeFabric.getActiveObject()
      t && this.$emit('upRotatedNum', Math.round(t.angle))
    })
    canObj.on('object:scaled', e => {
      if (e.target.time === this.activeGroupInfo.code) {
        this.$parent.createGroupImgEntry(this.activeGroupInfo.type)
      } else {
        const objects = canObj.getObjects()
        const group = objects.find(item => item.type === 'group')
        if (group && group.time === e.target.time) {
          this.$parent.createGroupImgEntry(group.groupType)
        }
      }
    })
    canObj.on('mouse:wheel', e => {
      const t = this.activeFabric.getActiveObject()
      t &&
        (() => {
          if (t.type === 'text') {
            this.setTipLevel(0)
          } else {
            t.tipLevel = this.getScaleInfo({ target: t })
            this.setTipLevel(t.tipLevel)
          }
          const upOrDown = e.e.wheelDelta
          t.set('scaleX', t.scaleX * (upOrDown > 0 ? 1.1 : 0.9)).setCoords()
          t.set('scaleY', t.scaleY * (upOrDown > 0 ? 1.1 : 0.9)).setCoords()
          this.activeFabric.renderAll()
          this.debounce(() => {
            if (t.time === this.activeGroupInfo.code) {
              this.$parent.createGroupImgEntry(this.activeGroupInfo.type)
            } else {
              const objects = canObj.getObjects()
              const group = objects.find(item => item.type === 'group')
              if (group && group.time === e.target.time) {
                this.$parent.createGroupImgEntry(group.groupType)
              } else {
                saveHistory()
              }
            }
          }, 300)

          this.setRandom()
        })()
    })
    canObj.on('object:scaling', e => {
      if (e.target.type === 'text') {
        this.setTipLevel(0)
      } else {
        e.target.tipLevel = this.getScaleInfo(e)
        this.setTipLevel(e.target.tipLevel)
      }
    })
    canObj.on('object:modified', e => {
      this.setRandom()
      saveHistory()
    })
    // canObj.on('object:added', e => {
    //   if (e.target.type === 'group') {
    //     return
    //   }

    //   const { initialSize, activeDesign } = this
    //   this.getOnePxToRealWidth(activeDesign, initialSize)
    //   e.target.tipLevel = this.getScaleInfo(e)
    //   console.log(e.target.tipLevel)
    //   this.setTipLevel(e.target.tipLevel)
    // })

    canObj.on('object:removed', e => {
      this.setTextValue(this.$t('generic.enterContent'))
      this.$nextTick(() => {
        if (e.target.type === 'group') {
        } else {
          this.setTipLevel(0)
          const activeObject = this.activeFabric.getActiveObject()
          if (!activeObject) {
            this.setCanvasType('')
          }
        }
      })

      if (this.activeGroupInfo.code === e.target.time) {
        const objects = canObj.getObjects()
        const group = objects.find(item => item.type === 'group')
        if (group) {
          canObj.remove(group)
          canObj.renderAll()
        }
      } else {
        const objects = canObj.getObjects()
        const group = objects.find(item => item.type === 'group')
        if (group && group.time === e.target.time) {
          canObj.remove(group)
          canObj.renderAll()
        }
      }
      if (e.target.type !== 'group') {
        saveHistory()
      }
      this.setRandom()
    })

    canObj.on('mouse:down', e => {
      console.log(e)
      const type = e.target === null ? '' : e.target.type
      console.log('type====', type)
      this.setCanvasType(type)
      if (type === 'text') {
        this.$emit('upMenuLeftIndex', 2)
      }
      if (e.target === null || e.target === undefined) {
        this.setTipLevel(0)
        this.$parent.setGroupType({ activeDesign: this.activeDesign, data: 0 })
        this.$parent.setGroupPaddingX({ activeDesign: this.activeDesign, data: 0 })
        this.$parent.setGroupPaddingY({ activeDesign: this.activeDesign, data: 0 })
      }
      if (type === 'text') {
        this.setTipLevel(0)
        // this.setActiveTab(3)
        this.setFont(e.target.fontFamily)
        this.setFontSize(e.target.fontSize)
        this.setTextValue(e.target.text)
      } else if (type === 'image') {
        e.target.tipLevel = this.getScaleInfo(e)
        this.setTipLevel(e.target.tipLevel)
        if (e.target.time === this.activeGroupInfo.code) {
          this.$parent.setGroupType({ activeDesign: this.activeDesign, data: e.target.groupType })
          this.$parent.setGroupPaddingX({ activeDesign: this.activeDesign, data: e.target.paddingX })
          this.$parent.setGroupPaddingY({ activeDesign: this.activeDesign, data: e.target.paddingY })
        } else {
          this.$parent.setGroupType({ activeDesign: this.activeDesign, data: 0 })
          this.$parent.setGroupPaddingX({ activeDesign: this.activeDesign, data: 0 })
          this.$parent.setGroupPaddingY({ activeDesign: this.activeDesign, data: 0 })
        }
      }
      const t = this.activeFabric.getActiveObject()
      if (t) {
        this.$emit('upRotatedNum', Math.round(t.angle))
      }
      this.setWhSize()
    })
    this.canObj = canObj
    this.$nextTick(() => {
      this.canvasWrapResize()
    })
    const _this = this
    window.onresize = function() {
      _this.canvasWrapResize()
    }
    // this.index === this.fabricList.length - 1 && this.getCopyProductId && this.$emit('canvasLoaded')
    // this.index === this.$emit('loaded')
  },
  computed: {
    ...mapGetters(['activeFabric', 'activeGroupInfo', 'tipLevel', 'getCopyProductId']),

    ...mapState({
      fabricList: state => state.design.fabricList,
      // 批量定制存的json数据
      activeFabricListGroup: state => state.gruopDesign.activeFabricListGroup,
      activeDesign: state => state.design.activeDesign,
      initialSize: state => state.design.initialSize,
      printImgInfo: state => state.design.printImgInfo,
      print_areas: state => state.design.print_areas,
      onePxToRealWidth: state => state.design.onePxToRealWidth,
      groupInfo: state => state.design.groupInfo
    })
  },
  watch: {
    activeDesign(val) {
      const { initialSize } = this
      // const { actual_sizes } = this.printImgInfo
      // const actualSizeObj = actual_sizes.find(item => item.view_id === val && item.size_id === initialSize)
      // const printAreas = this.print_areas.find(item => item.view_id === val)
      // const onePxToRealWidth = parseInt(actualSizeObj.actual_width) / parseInt(printAreas.width)
      // this.onePxToRealWidth = onePxToRealWidth
      this.$nextTick(() => {
        this.canvasWrapResize()
      })
      this.getOnePxToRealWidth(val, initialSize)
    },
    initialSize(val) {
      const { activeDesign } = this
      // const { actual_sizes } = this.printImgInfo
      // const actualSizeObj = actual_sizes.find(item => item.view_id === activeDesign && item.size_id === val)
      // const printAreas = this.print_areas.find(item => item.view_id === activeDesign)
      // const onePxToRealWidth = parseInt(actualSizeObj.actual_width) / parseInt(printAreas.width)
      // this.onePxToRealWidth = onePxToRealWidth
      this.getOnePxToRealWidth(activeDesign, val)
    }
  },
  methods: {
    canvasMousewheel(e) {
      e.preventDefault()
    },
    canvasWrapResize() {
      // var canvasSizer = this.$refs.canvasWrap
      // var width = canvasSizer.offsetWidth
      // var height = canvasSizer.offsetHeight
      const designWrap = document.body.getElementsByClassName('designWrap')[0]
      const wrapWidth = designWrap.offsetWidth
      const wrapHeight = designWrap.offsetHeight
      let width = 0
      let height = 0
      console.log(wrapHeight, wrapWidth)
      if (wrapWidth > 1780) {
        width = 700
        height = 700
      } else {
        width = 550
        height = 550
      }
      var canvas = this.canObj
      var scale = width / canvas.getWidth()
      var zoom = canvas.getZoom()
      zoom *= scale
      this.setZoom(zoom)
      canvas.setDimensions({
        width: width,
        height: height
      })
      canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0])
    },
    debounce(fn, time) {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setTimeout(() => {
        fn()
      }, time)
    },

    getTip(deforLevelH, deforLevelW) {
      const whichTip = deforLevelW >= deforLevelH ? deforLevelW : deforLevelH
      if (whichTip > 0 && whichTip < 0.1) {
        return 1
      }
      if (whichTip > 0.1 && whichTip < 0.4) {
        return 2
      }
      if (whichTip > 0.4) {
        return 3
      }
      return 0
    },
    getOnePxToRealWidth(activeDesign, initialSize) {
      const { actual_sizes } = this.printImgInfo
      const actualSizeObj = actual_sizes.find(item => item.view_id === activeDesign && item.size_id === initialSize)
      const printAreas = this.print_areas.find(item => item.view_id === activeDesign)
      const onePxToRealWidth = parseInt(actualSizeObj.actual_width) / parseInt(printAreas.width)
      // this.onePxToRealWidth = onePxToRealWidth
      this.setPx(onePxToRealWidth)
    },
    getScaleInfo(e) {
      const { initialSize, activeDesign } = this
      this.getOnePxToRealWidth(activeDesign, initialSize)
      const { height, width, scaleX, scaleY, pxH, pxW } = e.target
      const { dpi } = this.printImgInfo
      const realHeight = (height * scaleY * this.onePxToRealWidth * this.cmToInch) / 10
      const realWidth = (width * scaleX * this.onePxToRealWidth * this.cmToInch) / 10
      // console.log(pxH / realHeight.toFixed(0), pxW / realWidth.toFixed(0))
      const deforLevelH = dpi - pxH / realHeight.toFixed(0) <= 0 ? 0 : dpi - pxH / realHeight.toFixed(0)
      const deforLevelW = dpi - pxW / realWidth.toFixed(0) <= 0 ? 0 : dpi - pxW / realWidth.toFixed(0)
      return this.getTip(deforLevelH / dpi, deforLevelW / dpi)
    },
    ...mapMutations({
      setFabricList: 'SET_FABRIC_LIST',
      setRandom: 'SET_RANDOM',
      setActiveTab: 'SET_ACTIVE_TAB',
      setFont: 'SET_FONT',
      setFontSize: 'SET_FONT_SIZE',
      setTipLevel: 'SET_TIP_LEVEL',
      setTextValue: 'SET_TEXT_VALUE',
      setPx: 'SET_ONE_PX_TO_REAL_WIDTH',
      setZoom: 'SET_ZOOM',
      setCanvasType: 'SET_CANVAS_TYPE',
      setWhSize: 'SET_Wh_SIZE'
    })
  }
}
</script>

<style lang="less" scoped>
.canvasWrap {
  height: 700px;
  width: 700px;
  position: relative;
  background-image: url('../../../assets/back.png');
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  transform: scale(1, 1);
  .clipImg {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    z-index: 8;
  }
}
</style>
